export default __webpack_public_path__ + "static/circle-economy-banner-85910d94aa226a2c91cece90db9d5150.png";